export class Account {
    userId: string;
    tenantId: string
    password: string
    fullName: string
    email: string
    status: string
    role: string
}